// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"749":"a51c82fc","903":"8c3c57b6"}[chunkId] + ".chunk.js";
};